import { getShareData } from './set-aio-share'
/**
 * 设置标题方法，解决ios部分app无法动态设置标题的问题
 *
 * @author tianjingsi
 * @date 2019-09-29
 * @param {*} title
 */
function setTitle (title) {
    document.title = title
    const ua = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(ua) && (/micromessenger/.test(ua) || /ddudriver/.test(ua))) {
        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        iframe.src = '//static.udache.com/gulfstream/webapp/css/image/sawtooth.png'
        iframe.style.height = 0
        iframe.style.width = 0
        iframe.style.position = 'absolute'
        iframe.style.top = 0
        iframe.style.left = 0

        const loaded = function loaded () {
            setTimeout(() => {
                iframe.removeEventListener('load', loaded)
                document.body.removeChild(iframe)
            }, 0)
        }
        iframe.addEventListener('load', loaded)
        document.body.appendChild(iframe)
    }
}
function setGlobalData (res) {
    window.SCENES = res.scenes
    window.GLOBAL_DATA = res.global
    window.PROJECT_ID = res.id
    window.BUSINESS_DATA = res.businessData
    // 设置 aio
    window.__DATA__ = {}

    // 设置分享
    const shareData = getShareData(res.global.share)
    // 挂载分享信息到window上，AIO 在微信中拉起分享时需要
    window.__DATA__.shareData = shareData
    return shareData
}
export default {
    setTitle,
    setGlobalData
}
